import React from "react";
import Section from "../../../HOC/Section";

const mapMarker = () => {
  return (
    <Section id="map">
      <div>
        <iframe
          title="mapMarker"
          src="https://m.amap.com/navi/?dest=114.29,22.73&destName=广东省深圳市龙岗区龙东鸿景春天103-39&hideRouteIcon=1&key=0cf777773b5fa48c22e6d4d94379236b"
          width="100%"
          height="450"
          frameBorder="0"
          style={{ border: 0, marginBottom: "-7px" }}
          allowFullScreen
        />
      </div>
    </Section>
  );
};

export default mapMarker;
